package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Compact category shortcut used on Home: a colored rounded tile with a Material Symbols icon and a
 * label beneath. [containerColor]/[contentColor] are passed by the caller from `AppTheme.colors`.
 */
@Composable
fun CategoryTile(
    label: String,
    iconName: String,
    containerColor: Color,
    contentColor: Color,
    modifier: Modifier = Modifier,
    onClick: (() -> Unit)? = null,
    // Illustrated category image (see [categoryImageRes]); when set it replaces the glyph icon.
    imageRes: org.jetbrains.compose.resources.DrawableResource? = null,
) {
    Column(
        modifier = modifier.then(if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.homeCategoryTile)
                .background(containerColor, AppTheme.shapes.tile),
            contentAlignment = Alignment.Center,
        ) {
            if (imageRes != null) {
                androidx.compose.foundation.Image(
                    painter = org.jetbrains.compose.resources.painterResource(imageRes),
                    contentDescription = null,
                    modifier = Modifier.size(AppTheme.sizes.categoryTile),
                )
            } else {
                AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = contentColor)
            }
        }
        Text(
            text = label,
            style = AppTheme.typography.labelSm,
            color = AppTheme.colors.onSurface,
            // Multiline labels ("Food &\nRestaurants") must center under the tile, not rag left.
            // Exactly two lines are always reserved (minLines = maxLines = 2) so every tile in a
            // grid row has the SAME height — a 3-line label used to make rows uneven.
            textAlign = androidx.compose.ui.text.style.TextAlign.Center,
            minLines = 2,
            maxLines = 2,
            overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis,
        )
    }
}
